import { Component, createSignal, For, onMount, Show } from "solid-js"
import { Img } from "../universal/image"
import { Blog } from "../../library/types";
import { RecentBlogPostsBar } from "../recently-blog-posts-bar";
import moment from "moment";

export const BlogCarousel: Component = () => {
    const [blogs, setBlogs] = createSignal<Blog[]>([]);
    const loadBlogs = async () => {
        const response = await fetch("/Home/GetBlogsJson");
        const json = await response.json();
        if (!json.Success) {
            return;
        }
        setBlogs(json.Data);
    };
    onMount(() => {
        loadBlogs();
    });
    return (
        <>
            <Show when={blogs()?.length > 0}>
                <div class="slick" data-options='{ "dots": false, "autoplay": false, "arrows": false, "adaptiveHeight": true }'>
                    <For each={[blogs()[0]]}>{(post, index) =>
                        <div class="slide" style={{ "display": index() == 0 ? "block" : "none", "padding-bottom": "20px" }}>
                            <div class="row">
                                <div class="col-md-8">
                                    <h2 class="featurette-heading">
                                        <a href={"/blog/index/" + post.Id}>{post.Title}</a> <small class="text-muted">Published on {moment(post.PublishOnDateUTC || post.DateAddedUTC).format("MMMM DD, yyyy")}</small>
                                    </h2>
                                    <p class="lead" innerHTML={post.Content}></p>
                                </div>
                                <div class="col-md-4">
                                    <Show when={post.BlogPostImages?.length}>
                                        <div>
                                            <a href={"/blog/index/" + post.Id}>
                                                <Img src={post.BlogPostImages[0].URL} mode="crop" width="400" style="width: 100%;" />
                                            </a>
                                        </div>
                                    </Show>
                                    <Show when={post.BlogPostImages?.length == 0}>
                                        <div style="background-color: #eee; height: 400px; width: 100%;"></div>
                                    </Show>
                                </div>
                            </div>
                        </div>
                    }</For>
                </div>
                <div>
                    <RecentBlogPostsBar blogs={blogs} />
                </div>
            </Show>
            <p style="margin-top: 20px;">
                <a href="/Blog/Search" class="btn btn-default bold-button-text">
                    <img src="/Content/icons/newspaper.svg" style="width: 20px; margin-right: 10px;" />
                    <span class="pos-rel" style="top: 2px;">
                        View all news blogs
                    </span>
                    <img src="/Content/icons/right-chevron.svg" style="width: 15px; margin-left: 5px;" />
                </a>
            </p>
            <p style="font-size: 1em;">
                <a href="/Feed/Blog?format=rss" class="bold-button-text mr-10" style="font-size: 11px;">
                    <img src="/Content/icons/rss.svg" style="width: 15px; margin-right: 5px;" /><span class="pos-rel" style="top: 2px;">RSS</span>
                </a>
                <a href="/Feed/Blog?format=atom" class="bold-button-text mr-10" style="font-size: 11px;">
                    <img src="/Content/icons/rss.svg" style="width: 15px; margin-right: 5px;" /><span class="pos-rel" style="top: 2px;">Atom</span>
                </a>
            </p>
        </>
    )
}